module.exports = __webpack_public_path__ + "static/flag_static-175e7712b13a86c7dac70a9e06c8aa80.png";